import { memo, ReactElement } from 'react'
import { useRecoilValue } from 'recoil'
import { accountProfitShareState } from '../../states/profit-shares-state'
import { NumericFormat } from 'react-number-format'
import moment from 'moment'

interface Props {
  readonly id: string
  readonly accountId: string
}

const Component = (props: Props): ReactElement | null => {
  const { id, accountId } = props
  const share = useRecoilValue(accountProfitShareState({ profitShareId: id, accountId }))

  if (!share) {
    return null
  }

  return (
    <tr>
      <td>
        <NumericFormat
          className="font-bold"
          valueIsNumericString
          displayType="text"
          contentEditable={false}
          value={share?.amount}
          thousandSeparator={','}
          decimalScale={2}
          prefix={`${share?.currency?.code} `}
        />
      </td>
      <td>
        <span
          className="badge badge-sm badge-primary"
          title={moment(share?.realizedAt).format('YYYY-MM-DD HH:mm')}>
          {moment(share?.realizedAt).fromNow()}
        </span>
      </td>
    </tr>
  )
}

export const ProfitSharesListItem = memo(Component)